import Lineup from './lineup';
import {PositionInLineup} from 'helpers/lineup-helper';
import Action from 'actions';

export default class LineupClassic extends Lineup {
    setPlayersByColumns({incomingValues: {team, lineupId}}) {
        const {sportConfig} = Action.getState();

        const params = {
            team,
            sportConfig,
            functions: this.exec(
                'getFunctionsToSetPlayersByColumns',
                {
                    lineupId,
                },
                {},
            ),
        };

        const players = PositionInLineup.set.inDependenceOnDistribution(params);

        return [...players];
    }
}
